/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from server controller files.
// Do not edit it manually.

import type ApiClient from '@common/router/request/api';
import type { TFetcher } from '@common/router/request/api';


type TControllerResult<TController, TMethod extends keyof TController> =
    TController[TMethod] extends (...args: any[]) => infer TResult ? Awaited<TResult> : never;

type TControllerFetcher<TController, TMethod extends keyof TController> = TFetcher<TControllerResult<TController, TMethod>>;

export type TControllers = {
};

export const createControllers = (
    api: Pick<ApiClient, 'createFetcher'>
): TControllers => (
{
}
);

export default createControllers;
